<script setup lang="ts">
import type { UpdateOrCreateExternalWorkshopEmployeeUser } from '~/types'

defineProps<{
  payload: UpdateOrCreateExternalWorkshopEmployeeUser
}>()

const emit = defineEmits<{ (e: 'submit', payload: UpdateOrCreateExternalWorkshopEmployeeUser): void }>()
</script>

<template>
  <FormKit
    v-slot="{ value }"
    :value="payload.data"
    type="form"
    :submit-label="$t(`defect.externalWorkshopEmployee.${payload.mode}.popup.button.label`)"
    @submit="(value: typeof payload.data) => emit('submit', { mode: payload.mode, data: value })"
  >
    <TheDevOnlyNiceJson :value="value" />
    <div class="grid grid-cols-2 gap-x-2">
      <FormKit
        name="name"
        type="text"
        label="Name"
        :help="$t('defect.externalWorkshopEmployee.popup.name.field.help')"
        validation="required|length:3"
      />
      <FormKit
        name="email"
        type="text"
        label="E-Mail"
        :help="$t('defect.externalWorkshopEmployee.popup.email.field.help')"
        validation="required|email"
        :disabled="payload.mode === 'update'"
      />
    </div>
  </FormKit>
</template>
